<div id="maindiv" class="print-container">
  <div *ngIf="jobcard && cyclist && bike">

    <div class="partner-logo" *ngIf="partnerData.Print_ShowLogo">
      <img [src]="partnerData.ImageURL"/>
    </div>

    <div class="jobcard-number">
      #{{ jobcard.JobCardNo }}
    </div>
    <div style="text-align:center; margin: 16px;" *ngIf="partnerData.ShowJobCardStatus && jobcard && jobcard.StatusID">
      {{ getStatusDescription() }}
    </div>
    <div class="jobcard-number" style="margin-top: -16px;" *ngIf="partnerData.ShowJobCardBarcode && jobcardBarcode">
      <ngx-barcode6 [bc-value]="jobcardBarcode" [bc-display-value]="false" [bc-height]="50" [bc-width]="3"
                    [bc-format]="'CODE128'"></ngx-barcode6>
      <!--   todo(dcorbett)=ngx barcode   -->
    </div>
    <div class="block">
      <div class="partner-title">{{ partnerData.Name }}</div>
      <div class="block-title">
        {{ 'bikeshop.print.customer_details' | translate }}:
      </div>
      <div class="block-content">
        <div>
          {{ cyclist.Name }} {{ cyclist.Surname }}
        </div>
        <div>
          {{ cyclist.Email }}
        </div>
        <div>
          {{ cyclist.PhoneNumber }}
        </div>
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.service_type' | translate }}:
      </div>
      <div class="block-content">
        <div>
          {{ serviceTypes }}
        </div>
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.bike_details' | translate }}:
      </div>
      <div class="block-content">
        <div>
          {{ bike.Manufacturer }}
        </div>
        <div>
          {{ bike.Model }}
        </div>
        <div *ngIf="bike.SerialNo && bike.SerialNo.length>0">
          {{ bike.SerialNo }}
        </div>
      </div>
    </div>

    <div class="block" *ngIf="jobcard.BikeBay">
      <div class="block-title">
        {{ 'bikeshop.modal.shared.bike.bay_tag_number' | translate }}:
      </div>
      <div class="block-content">
        <div>
          {{ jobcard.BikeBay  }}
        </div>
      </div>
    </div>


    <!-- <div class="block" *ngIf="jobcard.BikeBay && jobcard.BikeBay.length>0">
    <div class="block-title">
      {{ 'bikeshop.modal.shared.bike.bay_tag_number' | translate }}:
    </div>
    <div class="block-content">
      <div>
        {{ jobcard.BikeBay }}
      </div>
    </div>
  </div> -->
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.scheduled_date' | translate }}:
      </div>
      <div class="block-content">
        {{ jobcard.DateCheckedIn | DateFormatPipe: displayDateTimeFormat }}
      </div>
    </div>
    <div class="block" *ngIf="jobcard.DateRequiredBy">
      <div class="block-title">
        {{ 'general.required_by' | translate }}:
      </div>
      <div class="block-content">
        {{ jobcard.DateRequiredBy | DateFormatPipe: displayDateTimeFormat }}
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.technician' | translate }}:
      </div>
      <div class="block-content">
        {{ jobcard.TechnicianDescription }}
      </div>
    </div>
    <div class="block" *ngIf="jobcard.Client_Notes && jobcard.Client_Notes.length>0">
      <div class="block-title">
        {{ 'bikeshop.print.client_notes' | translate }}:
      </div>
      <div class="block-content">
        <div [innerHTML]="jobcard.Client_Notes"></div>
      </div>
    </div>
    <div class="block" *ngIf="jobcard.InitialAssesment_Notes && jobcard.InitialAssesment_Notes.length>0">
      <div class="block-title">
        {{ 'bikeshop.print.external_notes' | translate }}:
      </div>
      <div class="block-content">
        <div [innerHTML]="jobcard.InitialAssesment_Notes ? jobcard.InitialAssesment_Notes : '-'"></div>
      </div>
    </div>
    <div class="block" *ngIf="partnerData.Print_ShowChecklist && checklist && checklist.length > 0">
      <div class="block-title">
        {{ 'bikeshop.print.checklist_items_for_this_job' | translate }}
      </div>
      <div class="block-content">
        <div *ngFor="let item of checklist" class="flex underline">
          <span>{{ item.description }}</span>
          <div *ngIf="item.controlType==='CHECKBOX'" class="check-value">
            <span *ngIf="!item.frontRearCheck">
              <span class="fa"
                    [ngClass]="{ 'fa-check-square-o' : item.defaultValue, 'fa-square-o' : !item.defaultValue || item.defaultValue ==='false' }"></span>
            </span>
            <span *ngIf="item.frontRearCheck">
              <b>F</b><span class="fa"
                            [ngClass]="{ 'fa-check-square-o' : item.frontValue, 'fa-square-o' : !item.frontValue || item.frontValue ==='false' }"></span>
            </span>
            <span *ngIf="item.frontRearCheck">
              <b>R</b><span class="fa"
                            [ngClass]="{ 'fa-check-square-o' : item.rearValue, 'fa-square-o' : !item.rearValue || item.rearValue ==='false' }"></span>
            </span>
          </div>
          <div *ngIf="item.controlType==='TEXT' || item.controlType==='RADIO' || item.controlType==='MULTILINETEXT'"
               class="text-value">
            <span *ngIf="!item.frontRearCheck && item.defaultValue">{{item.defaultValue}}</span>
            <span *ngIf="item.frontRearCheck && item.frontValue"><b>F:</b> {{item.frontValue}}</span>
            <span *ngIf="item.frontRearCheck && item.rearValue"><b>R:</b> {{item.rearValue}}</span>
          </div>
          <div *ngIf="item.controlType==='TRAFFICLIGHT'" class="text-value">
            <div class="radio-group" style="display: flex; gap: 6px;">
              <span class="fa" style="color: red; padding-top: 2%;" [ngClass]="{ 'fa-check-square-o' : item.defaultValue ==='Yes',             'fa-square-o' : !item.defaultValue || item.defaultValue !=='Yes' }"></span>
              <span class="fa" style="color: darkorange; padding-top: 2%;" [ngClass]="{ 'fa-check-square-o' : item.defaultValue ==='No',              'fa-square-o' : !item.defaultValue || item.defaultValue !=='No' }"></span>
              <span class="fa" style="color: green; padding-top: 2%;" [ngClass]="{ 'fa-check-square-o' : item.defaultValue ==='Not applicable',  'fa-square-o' : !item.defaultValue || item.defaultValue !=='Not applicable' }"></span>
              <span style="width:256px" *ngIf="!item.frontRearCheck && item.frontValue"><b></b> {{item.frontValue}}</span>
              <span style="width:125px" *ngIf="item.frontRearCheck && item.frontValue"><b>F:</b> {{item.frontValue}}</span>
              <span style="width:125px" *ngIf="item.frontRearCheck && item.rearValue"><b>R:</b> {{item.rearValue}}</span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- <div class="quote-footer">
    <div class="padding" *ngIf="quote && quote.LineItems.length > 0">
      <div class="row border-bottom">
        <div class="col-8 bold">{{ 'bikeshop.print.item' | translate }}</div>
        <div class="col-1 right bold">#</div>
        <div class="col-3 right bold">{{ 'bikeshop.print.price' | translate }}</div>
      </div>
      <div class="row" *ngFor="let lineItem of quote.LineItems">
        <div class="col-8">{{ lineItem.Description }}</div>
        <div class="col-1 right">{{ lineItem.Quantity }}</div>
        <div class="col-3 right">{{quote.CurrencySymbol}}{{ lineItem.Price | number : '.2-2' }}</div>
      </div>
      <div class="row border-top">
        <div class="col-9 right bold">{{ 'bikeshop.print.sub-total' | translate }}:</div>
        <div class="col-3 right bold">{{quote.CurrencySymbol}}{{ quote.Total_LineItems | number : '.2-2' }}</div>
      </div>
      <div class="row">
        <div class="col-9 right bold">{{ 'bikeshop.print.tax' | translate }}:</div>
        <div class="col-3 right bold">{{quote.CurrencySymbol}}{{ quote.Total_Tax | number : '.2-2' }}</div>
      </div>
      <div class="row">
        <div class="col-9 right bold">{{ 'bikeshop.print.total' | translate }}:</div>
        <div class="col-3 right bold">{{quote.CurrencySymbol}}{{ quote.Total_Price | number : '.2-2' }}</div>
      </div>
    </div>
  </div> -->
    <div class="quote-footer" *ngIf="partnerData.Print_ShowQuote">
      <div *ngIf="quote && quote.LineItems.length > 0">
        <div class="quote-row border-bottom">
          <div class="flex-8 bold">{{ 'bikeshop.print.item' | translate }}</div>
          <div class="flex-1 right bold">#</div>
          <div class="flex-3 right bold">{{ 'bikeshop.print.price' | translate }}</div>
        </div>
        <!-- Labour group -->
        <ng-container *ngIf="labourItems.length > 0">
          <div class="quote-group-header">{{ 'bikeshop.workshop.jobcard.labour' | translate }}</div>
          <div class="quote-row"
              [ngClass]="{'quote-row-barcode': partnerData.Print_ShowLineItemBarcode}"
              *ngFor="let lineItem of labourItems">
            <div class="flex-8">
              {{ lineItem.Name }}
              <div *ngIf="lineItem.LineItemNote" style="font-size: 90%;margin-top: -2px;">*{{lineItem.LineItemNote}}</div>
              <ngx-barcode6 *ngIf="partnerData.Print_ShowLineItemBarcode"
                [bc-value]="lineItem.SKU" [bc-display-value]="false" [bc-height]="50" [bc-width]="3"
                [bc-format]="'CODE128'"></ngx-barcode6>
            </div>
            <div class="flex-1 right">{{ lineItem.Quantity }}</div>
            <div class="flex-3 right">{{quote.CurrencySymbol}}{{ partnerData.VATInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.Price | number : '.2-2' }}</div>
          </div>
        </ng-container>
        <!-- Parts & Materials group -->
        <ng-container *ngIf="partsItems.length > 0">
          <div class="quote-group-header">{{ 'bikeshop.workshop.jobcard.parts_and_materials' | translate }}</div>
          <div class="quote-row"
              [ngClass]="{'quote-row-barcode': partnerData.Print_ShowLineItemBarcode}"
              *ngFor="let lineItem of partsItems">
            <div class="flex-8">
              {{ lineItem.Name }}
              <div *ngIf="lineItem.LineItemNote" style="font-size: 90%;margin-top: -2px;">*{{lineItem.LineItemNote}}</div>
              <ngx-barcode6 *ngIf="partnerData.Print_ShowLineItemBarcode"
                [bc-value]="lineItem.SKU" [bc-display-value]="false" [bc-height]="50" [bc-width]="3"
                [bc-format]="'CODE128'"></ngx-barcode6>
            </div>
            <div class="flex-1 right">{{ lineItem.Quantity }}</div>
            <div class="flex-3 right">{{quote.CurrencySymbol}}{{ partnerData.VATInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.Price | number : '.2-2' }}</div>
          </div>
        </ng-container>
        <div class="quote-row border-top">
          <div class="flex-9 right bold">{{ 'bikeshop.print.sub-total' | translate }}:</div>
          <div class="flex-3 right bold">{{quote.CurrencySymbol}}{{ quote.Total_LineItems | number : '.2-2' }}</div>
        </div>
        <div class="quote-row">
          <div class="flex-9 right bold">{{ 'bikeshop.modal.update_job_card.quote.discount' | translate }}:</div>
          <div class="flex-3 right bold">{{quote.CurrencySymbol}}{{ quote.Total_Discounts | number : '.2-2' }}</div>
        </div>
        <div class="quote-row" *ngIf="helpersService.showTaxRow(quote.Total_Tax, partnerData)">
          <div class="flex-9 right bold">{{ 'bikeshop.print.tax' | translate }}:</div>
          <div class="flex-3 right bold">{{quote.CurrencySymbol}}{{ quote.Total_Tax | number : '.2-2' }}</div>
        </div>
        <div class="quote-row">
          <div class="flex-9 right bold">{{ 'bikeshop.print.total' | translate }}:</div>
          <div class="flex-3 right bold">{{quote.CurrencySymbol}}{{ quote.Total_Price | number : '.2-2' }}</div>
        </div>
      </div>
    </div>

    <div class="qr-code" *ngIf="partnerData.PrintOutQRImageURL">
      <div>
        <img [src]="partnerData.PrintOutQRImageURL">
      </div>
    </div>
    <div class="print-terms" *ngIf="partnerData.PrintOutTerms">
      <div [innerHTML]="partnerData.PrintOutTerms"></div>
    </div>

    <div class="qr-container" *ngIf="url && url.length>0 && partnerData.PrintJobcardQRCode">
      <br/>
      <div class="flex-8">{{ 'bikeshop.modal.update_job_card.tab.attachments' | translate }} </div>
      <qrcode [qrdata]="url" colordark="rgba(30, 30, 30, 1)" usesvg="true" [width]="125"></qrcode>
    </div>

  </div>
</div>
